import GoBackMenu from '@/components/GoBackNavbar';
import StudentViewSection from '@/components/StudentViewSection';
import { useContentLanguageChange } from '@/hooks/useContentLanguageChange';
import { getViewTypeData, ViewType, viewTypeList } from '@/models/ViewType';
import { contentsClear } from '@/store/item/action';
import { coursesClear } from '@/store/list/action';
import { programsClear } from '@/store/program/action';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import PageNotFound from '../PageNotFound/PageNotFound';
import './style.scss';

const SectionPage: React.FC = () => {
    const { viewTypeResource } = useParams<{ viewTypeResource: string }>();

    const [refreshSection, setRefreshSection] = useState<boolean>(true);

    const dispatch = useDispatch();

    const viewType: ViewType | undefined = viewTypeList.find((viewType: ViewType) => getViewTypeData(viewType).resource === viewTypeResource);

    useContentLanguageChange({
        onChange: () => {
            dispatch(coursesClear());
            dispatch(contentsClear());
            dispatch(programsClear());
            setTimeout(() => setRefreshSection(true), 100);
        },
        unmountChange: () => setRefreshSection(false),
    });

    return (
        <div className="section-page">
            <GoBackMenu />
            {refreshSection && viewType && <StudentViewSection viewType={viewType} />}
            {!viewType && <PageNotFound />}
        </div>
    );
};
export default SectionPage;
